var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCheckinMenuItem = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.94193 7.49515C6.94959 8.86635 8.07464 9.97276 9.4549 9.96591C10.8367 9.9583 11.9503 8.842 11.9434 7.4708C11.9372 6.09883 10.8114 4.99318 9.43038 5.00003C8.04935 5.00612 6.93503 6.12394 6.94193 7.49515Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 18.9376C14.9854 15.4601 12.5107 12.6538 9.47312 12.6713C6.43556 12.6888 3.98545 15.5225 4.00007 19L15 18.9376Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3632 9.36173L17.9953 11.4669L21.8952 7.11674",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheckinMenuItem, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/CheckinMenuItem.4f87c3a5.svg";
export { ForwardRef as ReactComponent };